import { makeStyles } from '@material-ui/core/styles';

export function useAttendantSearchFiltersStyles() {
    const useStyles = makeStyles({
        form: {
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            gap: 16,
            padding: 16,
        },
        field: {
            minWidth: 180,
        },
        searchButton: {
            color: "#004F9F",
            backgroundColor: "#fff",
            border: "1px solid #004F9F",
            boxShadow: 'none',
            borderRadius: 5,
            textTransform: 'uppercase'
        },
        clearButton: {
            borderRadius: 5,
            color: "#ff9b38",
            borderColor: "#ff9b38",
            textTransform: 'uppercase'
        },
    });

    const classes = useStyles();
    return { classes };
}
